import { ReactElement } from 'react'
import { DoubleSide, Euler, MeshBasicMaterial } from 'three'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { Svg } from '@react-three/drei'

interface Props {
  hasSnowLoad: boolean
  pointForIcon: ImmutableVector3
  color?: string
  rotation?: Euler
  opacity?: number
}

const SnowLoadIcon = ({
  hasSnowLoad,
  pointForIcon,
  color = '#000000',
  rotation = new Euler(0, 0, 0), // No rotation to keep it vertical
  opacity = 1,
}: Props): ReactElement | null => {
  if (!hasSnowLoad) return null

  // Encode the SVG content to handle special characters
  const encodedSvg = encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
      color,
    )}" d="M21 11h-4.17l2.59-2.59L18 7l-3.99 4H13V6.83l4-3.99L15.59 2 13 4.59V0h-2v4.59L8.41 2 7 3.41l4 3.99V11h-1.99L5 7l-1.41 1.41L6.17 11H2v2h4.17l-2.58 2.59L5 17l3.99-4H11v4.17l-4 3.99L8.41 22 11 19.41V24h2v-4.59L15.59 22 17 20.59l-4-3.99V13h1.99l3.99 4 1.41-1.41L17.83 13H22v-2z"/></svg>`,
  )
  const svgData = `data:image/svg+xml,${encodedSvg}`

  return (
    <Svg
      src={svgData}
      position={[pointForIcon.v.x, pointForIcon.v.y, pointForIcon.v.z]}
      scale={0.01}
      rotation={rotation}
      fillMaterial={new MeshBasicMaterial({ color, side: DoubleSide, opacity, transparent: true })}
    />
  )
}

export default SnowLoadIcon
